import { render, staticRenderFns } from "./ClaimStatusSelector.vue?vue&type=template&id=8b0da2bc"
import script from "./ClaimStatusSelector.vue?vue&type=script&lang=js"
export * from "./ClaimStatusSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports